import styles from './ProblemsSolvedTitle.module.css';

type ProblemsSolvedTitleProps = {
  title: string;
};

export const ProblemsSolvedTitle = ({ title }: ProblemsSolvedTitleProps) => {
  return <h3 className={styles.problemsSolvedTitle}>{title}</h3>;
};
